import React, { useState, useEffect } from 'react';
import api from './api';
import { Chip, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

function VisitorCounter() {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    // Check if we have already counted this user
    // 'localStorage' persists even if they close the browser and come back
    const hasVisited = localStorage.getItem('hasVisitedChristmasMap');
    
    if (!hasVisited) {
      // CASE A: New Visitor -> Increment (+1)
      api.post('/visit')
        .then(res => {
          setVisits(res.data.visits);
          // Mark them as visited so we don't count them again
          localStorage.setItem('hasVisitedChristmasMap', 'true');
        })
        .catch(err => console.error("Error counting visit:", err));
    } else {
      // CASE B: Returning Visitor -> Just Get Count (No Increment)
      api.get('/visit/count')
        .then(res => {
          setVisits(res.data.visits);
        })
        .catch(err => console.error("Error fetching count:", err));
    }
  }, []);

  if (!visits) return null;

  return (
    <Tooltip title="Community members who have visited the map">
      <Chip 
        icon={<VisibilityIcon style={{ color: 'white' }} />} 
        label={`${visits.toLocaleString()} Festive Visits`}
        sx={{ 
          backgroundColor: '#d32f2f', 
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1rem',
          padding: '10px',
          mt: 2,
          boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
        }} 
      />
    </Tooltip>
  );
}

export default VisitorCounter;